<div class="main-container lg-view">
	<h3>Completed</h3>

	<div class="main-form" *ngIf="!isLoading">
		<form [formGroup]="completedStatusFormModel" @fadeIn @fadeOut>
			<fieldset>
				<legend>{{ job.jobName }} Result</legend>

				<div class="checkbox-group-container">
					<div class="label">Completed on</div>
					<div class="checkbox-group">
						<mat-checkbox *ngFor="let type of completionOptions"
							[checked]="type.id === completedStatusFormModel.get('completionDateType').value"
							[class.mat-checkbox-disabled]="false"
							[disabled]="type.id === completedStatusFormModel.get('completionDateType').value || isJobFlowDone"
							(change)="completedStatusFormModel.get('completionDateType').setValue(type.id)">
							{{ type.name }}</mat-checkbox>
					</div>
				</div>

				<mat-form-field class="calendar"
					*ngIf="isJobFlowDone || completedStatusFormModel.get('completionDate').enabled">
					<input matInput [matDatepicker]="picker" formControlName="completionDate"
						[disabled]="isJobFlowDone">
					<mat-datepicker-toggle matSuffix [for]="picker"
						[disabled]="isJobFlowDone || completedStatusFormModel.get('completionDate').disabled">
					</mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>

				<mat-form-field class="calendar"
					*ngIf="!isJobFlowDone && completedStatusFormModel.get('completionDate').disabled">
					<input matInput [value]="moment(selectedCompletionDate()).format('MM/DD/YYYY')" readonly
						(click)="onCompletionDateClick()">
				</mat-form-field>

				<mat-form-field *ngIf="showResultOptions">
					<mat-label>Result</mat-label>
					<mat-select formControlName="completionResult" [disabled]="isJobFlowDone">
						<mat-option *ngFor="let result of completionResults" [value]="result.id">
							{{result.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field>
					<mat-label>Comment</mat-label>
					<textarea matInput formControlName="comment" rows="4" [disabled]="isJobFlowDone"></textarea>
				</mat-form-field>
			</fieldset>
			<fieldset *ngIf="massCompletionAdditionalAssets" class="list">
				<legend>Additional Completed {{massCompletionAdditionalAssets.assetType}}</legend>

				<ul>
					<li *ngFor="let asset of massCompletionAdditionalAssets.assets">
						<mat-checkbox [disabled]="isJobFlowDone" (change)="onOtherAssetChange($event, asset.assetId)">
							{{asset.assetName}}</mat-checkbox>
					</li>
				</ul>
			</fieldset>
		</form>
	</div>
</div>

<div class="actions-container md-view" *ngIf="!isLoading">
	<ng-container *ngIf="isActionAvailable">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'..'"></action-button>
		<action-button [icon]="ButtonIcons.Submit" [name]="'Submit'" [clickAction]="completeJob.bind(self)"
			[disabled]="isActionDisabled"></action-button>
	</ng-container>

	<div class="actions-placeholder-message" *ngIf="pageType === PageType.Customer && (customerPreferences.preferences.isJobAutoSkipped || customerPreferences.preferences.isNotificationDisabled)">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>

	<div class="actions-placeholder-message" *ngIf="BitwiseHelper.and(pageType, PageType.AssigneeOrVendor) && customerPreferences.preferences.isJobAutoSkipped">
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
	</div>
</div>

<generic-modal #warningModal>
	<ng-template #modalBody>
		<p>This is set to <strong>{{selectedCompletionDateType()}}</strong> which is
			<strong>{{moment(selectedCompletionDate()).format('MM/DD/YYYY')}}</strong>.
		</p>
		<p>If you want to change it to a different date, please select <strong>Other</strong> above.</p>
	</ng-template>
	<ng-template #modalActions>
		<button mat-button (click)="warningModal.hide()">Ok</button>
	</ng-template>
</generic-modal>

<generic-modal [isPredefinedOpen]="job.isDataCollectionRequired && !canCompleteJob" #formsWarningModal>
	<ng-template #modalBody>
		<p class="padding-side">Current Job needs at least one form filed in order to complete it.</p>
	</ng-template>
	<ng-template #modalActions>
		<button mat-button (click)="formsWarningModal.hide()">Ok</button>
	</ng-template>
</generic-modal>